import React, { useState } from 'react';
import UserProductGrid from './userSide/userProductGrid';
import ArtisanCreateListingForm from './artisanCreateListingForm';
import ArtisanViewListings from './artisanViewListings';

const ProductsPage = () => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const isArtisan = true
  return (
    <section className='grid'>
      <div className="contentfront">
        <div className='justify top-page'>
          {/* User's View: Product Grid */}
          <h2>Supplies & Custom</h2>
          </div>
     <div>
          <UserProductGrid />

          {/* Artisan's Section: Check if user is an artisan */}
          {isArtisan && (
            <div>
              <button onClick={() => setShowCreateForm(!showCreateForm)}>
                {showCreateForm ? 'View My Listings' : 'Add New Product'}
              </button>
              {showCreateForm 
                ? <ArtisanCreateListingForm />
                : <ArtisanViewListings />
              }
            </div>
          )}
        </div>
        </div>
    </section>
  );
};

export default ProductsPage;
